import { Loader2, LucideProps } from "lucide-react";
import styles from "./styles.module.css";

export default function Spinner(props: LucideProps) {
  return <Loader2 className={styles.spinner} {...props} />;
}
